import axios from 'axios'
import config from '../../config'

import wrapper from 'axios-cache-plugin';

let postCache = wrapper(axios, {
  maxCacheSize: Infinity,
  ttl: 60000,
});

postCache.__addFilter(/details/);

const APIURL = config.apiUrl;

let paymentApi = {
  validateVoucher(model) {
    return axios.post(APIURL + 'providers/redeem', model);
  },
  getPaymentsPaginate(params) {
    return axios.get(APIURL + 'payments/', {
      params: {
        page: params.page,
        per_page: params.per_page,
        status: params.status,
        find: params.find.key,
        v: params.find.value
      }
    });
  },
  getRefundedPayments(params) {
    return axios.get(APIURL + 'payments/refunded', {
      params: {
        page: params.page,
        per_page: params.per_page,
      }
    });
  },
  updatePaymentStatus(model) {
    return axios.put(APIURL + 'payment/status', model);
  },
  refundPayment(model) {
    return axios.post(APIURL + 'payment/refund/', model);
  },
  addPayment(model) {
    return axios.post(APIURL + 'payment/', model);
  },
  deletePayment(id) {
    return axios.delete(APIURL + 'payment/' + id);
  },
  getPaypalTransaction(txn_id) {
    return axios.get(APIURL + 'paypal/transaction/' + txn_id);
  },
  getPayPalDetails() {
    return axios.get(APIURL + 'paypal/details');
  },
  getPayPalSubscriptionDetails() {
    return axios.get(APIURL + 'paypal/subscription/details');
  },
  getUuid() {
    return axios.get(APIURL + '/paypal/subscription/generate')
  },
  getStripePrices() {
    return axios.get(APIURL + 'stripe/get-prices/')
  },
  initalizePayment(data) {
    return axios.post(APIURL + 'stripe/initialize-payment/', data)
  },
  validatePayment(data) {
    return axios.post(APIURL + 'stripe/validate-payment/', data)
  },
  getUpcomingInvoice() {
    return axios.get(APIURL + 'stripe/upcoming-invoice/')
  },
  cancelCurrentSubscription() {
    return axios.post(APIURL + 'stripe/terminate-subscription/')
  },
  resumeCurrentSubscription() {
    return axios.post(APIURL + 'stripe/resume-subscription/')
  },

};

export default paymentApi;



// WEBPACK FOOTER //
// ./src/api/Payment/index.js